module.exports = __webpack_public_path__ + "img/ky.4601da33.png";